import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { UpdateUserProfile } from '@core/typings/client-user.typing';

@Injectable({ providedIn: 'root' })
export class ClientUserResources {

  constructor (
    private httpRestService: HttpRestService
  ) { }

  getUser () {
    return this.httpRestService.get('api/manager/user?includeRoles=true');
  }

  updateProfile (
    data: Partial<UpdateUserProfile>
  ) {
    return this.httpRestService.post('api/manager/user/updateprofile', data);
  }

  deactivateAccount () {
    const endpoint = 'api/manager/user/DeactivateAccount';

    return this.httpRestService.post(endpoint, { clearPersonalData: true });
  }
}


